<template>
  <select-form
    :name="fieldName"
    :selectable-items="prefectures"
    :default-item="defaultItem"
    :validator="validator"
    :dispatcher="dispatcher"
  />
</template>

<script setup>
import { watch } from "vue";
import { useStore } from "vuex";
import {
  usePrefectureIdField,
  usePrefectureIdStore
} from "@component_path/inquiry_form_common_module/custom_hook/PrefectureId";
import SelectForm from "@component_path/pages/pc/agent_selection/secret/components/form_element/Select";

const store = useStore();

const props = defineProps({
  required: {
    type: Boolean,
    required: false,
    default: false
  },
  defaultItem: {
    type: Object,
    required: false,
    default: {
      value: null,
      label: "都道府県"
    }
  }
});

const { fieldName, validator } = usePrefectureIdField(props.required);
const { prefectureId, prefectures, dispatcher } = usePrefectureIdStore();

watch(prefectureId, () => {
  store.dispatch("masterData/fetchCitiesFromExternal", prefectureId.value);
});

store.dispatch("masterData/fetchCitiesFromExternal", prefectureId.value);
</script>
